var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M330 299V574.5H423V601H712.5V758H848V601H826.5V288L759.5 221H669V299H330Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M712.5 601V758H642V738.5H418V1159.5H56L52 574.5H423V601H712.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M673 1159.5H418V740H641.5V836H673V1159.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M971 758H848V600H825.5V288L758 220.5L962 14.5L1238.5 294V719.5H1115V738H971V758Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M971 857.5V758V738H1115V719.5H1238.5V857.5V1160H950.5V857.5H971Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1499.5 1225.5V1160H1239V730H1353V740.5H1458V721H1524.5V743.5H1594.5V860H1778V1225.5H1499.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1594.5 860V744H1524.5V721H1458V741H1353V731H1238.5V298H1500.5V217.5H1804V299.5H1942.5V315H2080V449.5H2179V1009.5H2060.5V878.5H1900.5H1779V860H1594.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor16);
export default __webpack_public_path__ + "static/media/select-floor-16.8b6802cb.svg";
export { ForwardRef as ReactComponent };